import { executeRequest, Request, Response } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
import { Config } from 'react-native-config'

const responseParser = (data: Response) => {
  const responseObj = data?.data?.responseObject ?? []

  const nickName = {
    __typename: 'Nickname',
    id: 0,
    nickNameSuggestions: [],
    nickNameValidationPattern: null,
    nickNameValidationMessage: null,
  }

  if (responseObj && responseObj?.length > 0) {
    const item = responseObj[0]
    nickName.id = item?.product?.id ?? 0
    nickName.nickNameSuggestions = item?.config?.nickNameSuggestions ?? []
    nickName.nickNameValidationPattern = item?.config?.nickNameValidationPattern ?? null
    nickName.nickNameValidationMessage = item?.config?.nickNameValidationMessage ?? null
  }

  const ret = responseObj.map((item: any) => ({
    id: `${item?.product?.id}_${item?.standingInstruction?.templateId}`,
    displayName: item?.authInfo?.displayName,
    dataType: item?.authInfo?.dataType,
    fieldErrorMessage: item?.authInfo?.fieldErrorMessage,
    fieldValidationPattern: item?.authInfo?.fieldValidationPattern,
    enabled: item?.authInfo?.enabled,
  }))

  return {
    fieldData: ret,
    nickNamefield: nickName,
  }
}

const getAuthenticatorListBody = () => {
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: 3131,
      channelId: '1234',
    },
  }
}

export const getAuthenticatorList = (tokens, userAccessToken, billerMasterId: number) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.getAuthenticatorList,
    method: 'POST',
    body: {
      product: {
        id: billerMasterId,
      },
      ...getAuthenticatorListBody(),
    },
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.responseStatus?.code === '000') {
      return responseParser(data)
    }
    const errorMsg = {
      errorCode: data?.data?.error?.code,
      errorMessage: data?.data?.error?.message ?? null,
    }

    throw errorMsg
  })
}
